export default __webpack_public_path__ + "static/ISO27001-cbd71b1b948927b88891bcb3de703174.png";